import { clienteApi } from "@/api/ClienteApi";

class ClienteService {
  obterAssociado(idCliente: number) {
    return clienteApi.obterDadosCliente(idCliente);
  }

}

export const clienteService: ClienteService = new ClienteService();
